import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "linkShow", "linkHide", "content" ]

  connect() {
    this.linkHideTarget.style.display = 'none'
    this.contentTarget.style.display = 'none'

    this.linkShowTarget.addEventListener('click', (e) => {
      e.preventDefault()
      this.show();
    })

    this.linkHideTarget.addEventListener('click', (e) => {
      e.preventDefault()
      this.hide();
    })

  }

  show() {
    $(this.contentTarget).slideDown()
    $(this.linkShowTarget).fadeOut(300, () => $(this.linkHideTarget).show() )
  }

  hide() {
    $(this.contentTarget).slideUp()
    $(this.linkHideTarget).fadeOut(300, () => $(this.linkShowTarget).show() )
  }

}
